/**
 * The words the search placeholder rolls through ("Search ORTEX", "Search stocks", ...) and how long
 * each one holds. The roll is pure CSS (`.cycleWord` in Header.module.scss): its keyframes hold each
 * word for 1/length of the cycle and the cycle lasts length × SEARCH_STEP_S, so the SCSS repeats
 * both numbers. `e2e/unit/searchWords.spec.ts` fails when the two files disagree.
 */
export const SEARCH_WORDS = ["ORTEX", "stocks", "ETFs", "indexes", "insiders"];

/** Seconds each word is shown, including its roll in. */
export const SEARCH_STEP_S = 3;

/** The roll in, as a share of the whole cycle: the keyframes' first stop (2% of 5 × 3 s = 300 ms). */
export const SEARCH_ROLL_IN_FRACTION = 0.02;

/** Seconds of cycle: all the words, one step each. */
export const searchCycleS = () => SEARCH_WORDS.length * SEARCH_STEP_S;

/** Animation delay for word i: its slot in the cycle, pulled back by the roll in so word 0 is at rest at t=0. */
export const searchWordDelayS = (i: number) => i * SEARCH_STEP_S - SEARCH_ROLL_IN_FRACTION * searchCycleS();
